import { useEffect, useContext } from 'react';

import { HostingContext, SessionState, Session } from 'hosting/context';
import { useDispatch } from 'react-redux';
import {
  transformListFromSIdToId,
  transformListFromIdToSId,
} from 'services/transformListBetweenIdSId';
import {
  transformAssessmentsToSuspendData,
  transformAssessmentsFromSuspendData,
} from 'services/transformAssessmentsToAndFromSuspendData';
import getStore from 'services/getStore';
import { updateScoreAction } from 'actions/updateScoreAction';
import {
  // transformScoreDataFromIdToSId,
  transformScoreDataFromSIdToId,
} from 'services/transformScoreData';

interface ExtendedSession extends Session {
  learning_module_session?: { [key: string]: any };
}

export const PrepareHostedModuleSavedData = () => {
  const hostingContext = useContext(HostingContext);
  const dispatch = useDispatch();

  useEffect(() => {
    // console.log('reads hosting context', hostingContext);
    if (!hostingContext) {
      return;
    }

    hostingContext.current().then(($: ExtendedSession) => {
      //
      //
      console.log($);

      const { session_data } = $.learning_module_session || {};
      const { location } = session_data || {};
      const {
        scoreData = {},
        interactionsSeen = [],
        interactionsLocked = [],
        landingPagesSeenState = {},
        assessments = {},
        moduleVariables = {},
      } = session_data?.data || {};

      const state = getStore().getState();
      const { idToSIdMap, sIdToIdMap } = state;

      const transformedInteractionsSeen = transformListFromSIdToId(
        sIdToIdMap,
        interactionsSeen
      );

      const transformedInteractionsLocked = transformListFromSIdToId(
        sIdToIdMap,
        interactionsLocked
      );

      let transformedAssessments = assessments;
      if (Object.keys(assessments).length) {
        transformedAssessments = transformAssessmentsFromSuspendData(
          assessments,
          state
        );
      }

      //

      let transformedScoreData = { ...scoreData };
      if (scoreData) {
        transformedScoreData = transformScoreDataFromSIdToId(scoreData, state);
      }

      dispatch({
        type: 'LOAD_SUSPEND_DATA',
        data: {
          scoreData: transformedScoreData,
          interactionsSeen: transformedInteractionsSeen,
          interactionsLocked: transformedInteractionsLocked,
          landingPagesSeenState,
          assessments: transformedAssessments,
          moduleVariables,
        },
      });

      if (location) {
        console.log('LOAD_BOOKMARK_DATA', location);

        dispatch({
          type: 'LOAD_BOOKMARK_DATA',
          data: location,
        });
      }

      if (interactionsSeen.length) {
        console.log('UPDATE_INTERACTIONS_SEEN', transformedInteractionsSeen);

        dispatch({
          type: 'UPDATE_INTERACTIONS_SEEN',
          data: transformedInteractionsSeen,
        });
      }

      let hasReloadedScoreData;
      if (scoreData && !hasReloadedScoreData) {
        Object.keys(scoreData).forEach((entry: any, index) => {
          dispatch(updateScoreAction(entry, scoreData[entry]));
        });

        hasReloadedScoreData = true;
      }
    });
  }, []);

  return null;
};
